import axios from "axios";

const BACKEND_URL = "";
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true, timeout: 300000 });

export const api = {
  get: (p, cfg) => client.get(p, {timeout:20000,...cfg}).then((r) => r.data),
  post: (p, body, cfg) => client.post(p, body, cfg).then((r) => r.data),
  patch: (p, body) => client.patch(p, body).then((r) => r.data),
  put: (p, body) => client.put(p, body).then((r) => r.data),
  del: (p, cfg) => client.delete(p, cfg).then((r) => r.data),
  raw: client,
};

export default api;

